import React from 'react';
import styled from 'styled-components';

const DashboardContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
`;

const DashboardCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 3rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h1`
  color: #333;
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2.5rem;
  font-weight: 600;
`;

const Subtitle = styled.p`
  color: #666;
  text-align: center;
  margin-bottom: 3rem;
  font-size: 1.1rem;
  line-height: 1.6;
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
`;

const FeatureCard = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 2rem;
  border: 1px solid #e1e5e9;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }
`;

const FeatureIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
  text-align: center;
`;

const FeatureTitle = styled.h3`
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.3rem;
  font-weight: 600;
  text-align: center;
`;

const FeatureDescription = styled.p`
  color: #666;
  line-height: 1.6;
  text-align: center;
`;

const CTASection = styled.div`
  text-align: center;
  padding: 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  color: white;
`;

const CTATitle = styled.h2`
  margin: 0 0 1rem 0;
  color: white;
`;

const CTADescription = styled.p`
  margin: 0;
  opacity: 0.9;
  color: white;
`;

const CTAButton = styled.button`
  background: white;
  color: #667eea;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  margin-top: 1rem;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(255, 255, 255, 0.3);
  }
`;

const DashboardPage: React.FC = () => {
  const handleStartChat = () => {
    window.location.href = '/chat';
  };

  return (
    <DashboardContainer>
      <DashboardCard>
        <Title>Bem-vindo ao AI Chat App</Title>
        <Subtitle>
          Uma aplicação de chat moderna com integração de IA powered by DeepSeek. 
          Converse em tempo real com outros usuários ou interaja com assistentes de IA inteligentes.
        </Subtitle>

        <FeatureGrid>
          <FeatureCard>
            <FeatureIcon>💬</FeatureIcon>
            <FeatureTitle>Chat em Tempo Real</FeatureTitle>
            <FeatureDescription>
              Mensagens instantâneas com conexões WebSocket seguras e indicadores de digitação.
            </FeatureDescription>
          </FeatureCard>

          <FeatureCard>
            <FeatureIcon>🤖</FeatureIcon>
            <FeatureTitle>Assistente de IA</FeatureTitle>
            <FeatureDescription>
              Integração com modelos de IA avançados da DeepSeek para conversas inteligentes.
            </FeatureDescription>
          </FeatureCard>

          <FeatureCard>
            <FeatureIcon>👥</FeatureIcon>
            <FeatureTitle>Usuários Online</FeatureTitle>
            <FeatureDescription>
              Veja quem está online e gerencie suas conversas em grupo facilmente.
            </FeatureDescription>
          </FeatureCard>

          <FeatureCard>
            <FeatureIcon>📱</FeatureIcon>
            <FeatureTitle>Design Responsivo</FeatureTitle>
            <FeatureDescription>
              Interface moderna que funciona perfeitamente em desktop e dispositivos móveis.
            </FeatureDescription>
          </FeatureCard>

          <FeatureCard>
            <FeatureIcon>🔒</FeatureIcon>
            <FeatureTitle>Seguro</FeatureTitle>
            <FeatureDescription>
              Autenticação JWT, criptografia de ponta a ponta e proteção de dados.
            </FeatureDescription>
          </FeatureCard>

          <FeatureCard>
            <FeatureIcon>⚡</FeatureIcon>
            <FeatureTitle>Performance</FeatureTitle>
            <FeatureDescription>
              Carregamento rápido, cache inteligente e otimizações para melhor experiência.
            </FeatureDescription>
          </FeatureCard>
        </FeatureGrid>

        <CTASection>
          <CTATitle>Pronto para começar?</CTATitle>
          <CTADescription>
            Entre no chat e comece a conversar com outros usuários ou experimente nosso assistente de IA.
          </CTADescription>
          <CTAButton onClick={handleStartChat}>
            Ir para o Chat
          </CTAButton>
        </CTASection>
      </DashboardCard>
    </DashboardContainer>
  );
};

export default DashboardPage;
